<template>
<div>
	<el-form :model="changeForm" ref="changeFormRef" :rules="changeFormRules" :label-position="formSet.label" label-width="120px" :size="formSet.size">
	    <el-form-item label="销售订单号:" prop="vbeln" v-if="!pageData.isBatch">
	        <el-input v-model="changeForm.vbeln" disabled></el-input>
	    </el-form-item>
		<el-form-item label="未开票原因:" v-if="pageType==1" prop="vatOverdueDesc">
        <el-select
          v-model="changeForm.vatOverdueDesc"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option value="未完全收货" label="未完全收货"></el-option>
          <el-option value="客户取消" label="客户取消"></el-option>
          <!--				<el-option value="2" label="重复订单"></el-option>-->
          <el-option value="退货未核销" label="退货未核销"></el-option>
          <!--				<el-option value="4" label="其他原因"></el-option>-->
          <el-option value="符合开票条件" label="符合开票条件"></el-option>
          <el-option value="客户不开票" label="客户不开票"></el-option>
			</el-select>
	    </el-form-item>
	    <el-form-item label="未回款原因:" v-if="pageType==2" prop="backOverdueDesc">
        <el-select
          v-model="changeForm.backOverdueDesc"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option value="发票未送达" label="发票未送达"></el-option>
          <!--				<el-option value="1" label="回款未匹配"></el-option>-->
          <el-option value="客户无预算" label="客户无预算"></el-option>
          <!--				<el-option value="3" label="提前开票"></el-option>-->
          <!--				<el-option value="4" label="其他原因"></el-option>-->
          <el-option value="发票丢失" label="发票丢失"></el-option>
          <el-option value="客户已回款" label="客户已回款"></el-option>
          <el-option value="已收票未挂账" label="已收票未挂账"></el-option>
          <el-option value="客户取消" label="客户取消"></el-option>
			</el-select>
	    </el-form-item>
	    <el-form-item label="预计开票日期:" v-if="pageType==1" prop="predictVatDat">
        <el-date-picker
          v-model="changeForm.predictVatDat"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 100%"
        ></el-date-picker>
	    </el-form-item>
	    <el-form-item label="预计回款日期:" v-if="pageType==2" prop="predictBackDat">
        <el-date-picker
          v-model="changeForm.predictBackDat"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 100%"
        ></el-date-picker>
	    </el-form-item>
	    <el-form-item label="首次跟进人:" prop="firstFollower">
	        <el-input v-model="changeForm.firstFollower" disabled></el-input>
	    </el-form-item>
	    <el-form-item label="当前跟进人:" prop="creator">
	        <el-input v-model="changeForm.creator" disabled></el-input>
	    </el-form-item>
    <el-form-item label="协同邮件:" filterable>
      <el-select
          v-model="changeForm.email"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="getEmailList"
      >
        <el-option value="" label="不发送邮件"></el-option>
        <el-option
            v-for="(item, index) in emailList"
            :key="index"
            :label="item"
            :value="item"
        >
        </el-option>
      </el-select>
    </el-form-item>
	    <el-form-item label="备注说明:" prop="feedbackRemark">
	        <el-input v-model="changeForm.feedbackRemark" type="textarea"></el-input>
	    </el-form-item>
	    <el-form-item label="重复订单:" prop="repeatOrderNumber" v-if="showRepeatOrderFields">
	        <el-input v-model="changeForm.repeatOrderNumber" placeholder="若是重复做单，请填写重复订单的link单号；不是则不填"></el-input>
	    </el-form-item>
	    <el-form-item label="是否有客户证明:" prop="hasCustomerProof" v-if="showRepeatOrderFields">
	        <el-radio v-model="changeForm.hasCustomerProof" :label="1">有</el-radio>
	        <el-radio v-model="changeForm.hasCustomerProof" :label="0">无</el-radio>
	    </el-form-item>
		<el-form-item :label="showRepeatOrderFields && changeForm.hasCustomerProof === 1 ? '上传图片:' : '上传图片:'" prop="imageUrls" :required="showRepeatOrderFields && changeForm.hasCustomerProof === 1">
			<div class="img-uploader" v-if="changeForm.imageUrls && changeForm.imageUrls.length">
				<div class="el-upload" v-for="(item, index) in changeForm.imageUrls" :key="index">
					<img :src="item" class="img" />
					<span class="delete" @click.stop="uploadImgDelete(index)">
						<i class="el-icon-delete"></i>
					</span>
				</div>
			</div>
			<el-upload
				v-if="changeForm.imageUrls && changeForm.imageUrls.length < 5"
				class="img-uploader"
				:action="`${$http.defaults.baseURL}/reqorder/upload`"
				accept="image/*"
				:headers="{user_login_token: $store.state.token}"
				:show-file-list="false"
				:before-upload="beforeImgUpload"
				:on-success="uploadImgSuccess">
				<i class="el-icon-plus img-uploader-icon"></i>
			</el-upload>
		</el-form-item>
      <el-form-item label-width="0" style="text-align: center">
			<el-button type="primary" @click="submitChangeForm()">提交</el-button>
			<el-button @click="changeFlag(false)">关闭</el-button>
	    </el-form-item>
	</el-form>
</div>
</template>
<script>
import util from "../../common/util";
export default {
	name: "RMSFeedback",
	props: ["pageData"],
	data() {
		return {
      nickName: sessionStorage.getItem("NICKNAME"),
			pageType: 1,
			formSet: {
        label: "right",
        size: "small",
			},
			changeForm: {
				id: "",
				vbeln: "",
				vatOverdueDesc: "",
				backOverdueDesc: "",
				predictVatDat: "",
				predictBackDat: "",
				firstFollower: "",
				creator: "",
				email: "",
				feedbackRemark: "",
				imageUrls: [],
				repeatOrderNumber: "",
				hasCustomerProof: "",
			},
			// 表单验证
			changeFormRules: {
				vatOverdueDesc: [
					{ required: true, message: "请填写未开票原因", trigger: "blur" },
				],
				backOverdueDesc: [
					{ required: true, message: "请填写未回款原因", trigger: "blur" },
				],
				predictVatDat: [
					{ required: true, message: "请选择日期", trigger: "blur" },
				],
				predictBackDat: [
					{ required: true, message: "请选择日期", trigger: "blur" },
				],
				// firstFollower: [
				// 	{ required: true, message: "请填写首次跟进人", trigger: "blur" },
				// ],
				creator: [
					{ required: true, message: "请填写当前跟进人", trigger: "blur" },
				],
				feedbackRemark: [
					{ required: true, message: "请填写备注说明", trigger: "blur" },
				],
				hasCustomerProof: [
					{ 
						validator: (rule, value, callback) => {
							if (this.showRepeatOrderFields) {
								if (value === "" || value === null || value === undefined) {
									callback(new Error("请选择是否有客户证明"));
								} else {
									callback();
								}
							} else {
								callback();
							}
						}, 
						trigger: "change" 
					},
				],
				imageUrls: [
					{ 
						validator: (rule, value, callback) => {
							if (this.showRepeatOrderFields && this.changeForm.hasCustomerProof === 1) {
								if (!value || value.length === 0) {
									callback(new Error("客户证明选择有，请上传图片"));
								} else {
									callback();
								}
							} else {
								callback();
							}
						}, 
						trigger: "change" 
					},
				],
			},
			changeFormFlag: {
				vatOverdueDesc: false,
				backOverdueDesc: false,
				predictVatDat: false,
				predictBackDat: false,
			},
      emailList: [],
		};
	},
	computed: {
		// 当未开票原因选择"客户取消"时显示重复订单和是否有客户证明
		showRepeatOrderFields() {
			return this.changeForm.vatOverdueDesc === "客户取消" || this.changeForm.backOverdueDesc === "客户取消";
		},
	},
	created() {
		if(this.pageData.clientType=="mobile"){ //手机
      this.formSet.label = "top";
      this.formSet.size = "mini";
    }
		this.init();
	},
	methods: {
		// 初始化
		init(){
      this.getEmailList();
			this.pageType = this.pageData.type;
			for(let item in this.changeForm){
        this.changeForm[item] = this.pageData[item] ? this.pageData[item] : "";
      }
			this.changeForm.creator = this.nickName;
      this.changeForm.feedbackRemark = "";
			if(!this.changeForm.firstFollower){
				this.changeForm.firstFollower = this.nickName;
      }
			if(!this.changeForm.imageUrls){
				this.changeForm.imageUrls = [];
      }
			// 初始化新字段
			if(this.changeForm.repeatOrderNumber === undefined){
				this.changeForm.repeatOrderNumber = "";
      }
			if(this.changeForm.hasCustomerProof === undefined){
				this.changeForm.hasCustomerProof = "";
      }
			if(this.changeForm.predictVatDat){
        this.changeForm.predictVatDat = util.formatDate(
          this.changeForm.predictVatDat,
          "",
          1
        );
      }
			if(this.changeForm.predictBackDat){
        this.changeForm.predictBackDat = util.formatDate(
          this.changeForm.predictBackDat,
          "",
          1
        );
      }
			
			for(let item in this.changeFormFlag){
				this.changeFormFlag[item] = this.changeForm[item] ? true : false;
      }
		},
		// 图片上传-验证
		beforeImgUpload(file) {
			const isJPG = file.name.substring(file.name.lastIndexOf(".") + 1) === "jpg";
			const isJPEG = file.name.substring(file.name.lastIndexOf(".") + 1) === "jpeg";
			const isPNG = file.name.substring(file.name.lastIndexOf(".") + 1) === "png";
			const isBMP = file.name.substring(file.name.lastIndexOf(".") + 1) === "bmp";
			const isGIF = file.name.substring(file.name.lastIndexOf(".") + 1) === "gif";
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isJPG && !isJPEG && !isPNG && !isBMP && !isGIF) {
				this.$message.error("图片只能是 jpg、jpeg、png、bmp、gif 格式!");
			} else if (!isLt2M) {
				this.$message.error("图片大小不能超过 2MB!");
      }
			return (isJPG || isJPEG || isPNG || isBMP || isGIF) && isLt2M;
		},
		// 图片上传-返回
		uploadImgSuccess(res, file) {
			if (res.code==200) {
				this.changeForm.imageUrls.push(res.result.url);
				return true;
      }
			this.$message({
				message: res.message,
				type: "error",
			});
		},
		// 图片上传-删除
		uploadImgDelete(index){
			this.changeForm.imageUrls.splice(index, 1);
		},
		// 提交
		async submitChangeForm(){
			this.$refs.changeFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        
        // 手动验证：当显示重复订单字段且客户证明选择"有"时，必须上传图片
        if (this.showRepeatOrderFields && this.changeForm.hasCustomerProof === 1) {
          if (!this.changeForm.imageUrls || this.changeForm.imageUrls.length === 0) {
            this.$message({
              type: "warning",
              message: "客户证明选择有，请上传图片",
            });
            return;
          }
        }

        let res2 = "";

        if (this.pageData.isBatch) {
          //批量反馈
          if (!this.pageData.params) {
						this.$message({
              type: "warning",
              message: "无可反馈订单",
            });
            return;
          }
          res2 = await this.$api.receivableSubmitFeedback(
            {
              ...this.changeForm,
              ...this.pageData.params,
            }
          );
        } else {
          let vbelns = [];
          vbelns.push(this.changeForm.vbeln)
          res2 = await this.$api.receivableSubmitFeedback({
            ...this.changeForm,
            vbelns: vbelns,
          });
        }

        if (res2.code == 200) {
          this.$message({
            type: "success",
            message: "成功",
						});
						this.changeFlag(true);
        }
			});
		},
		// 关闭弹窗
		changeFlag(flag){
      this.$emit("successFeedback", flag);
		},
    async getEmailList() {
      let res = await this.$http.post("/receivable/getEmailList", {});
      if (res.code == 200) {
        this.emailList = res.result;
      } else {
        this.emailList = [];
      }
    },
  },
};
</script>
<style lang="less" scoped>
.img-uploader {
	display: inline-block;
	vertical-align: top;
	/deep/.el-upload {
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		margin-bottom: 10px;
		margin-right: 10px;
		&:hover {
			.delete {
				display: block;
			}
		}
	}
	.img {
		display: block;
		width: 80px;
		height: 80px;
	}
	.delete {
		height: 24px;
		line-height: 24px;
		padding: 0 5px;
		font-size: 16px;
		color: #fff;
		background: rgba(0,0,0,0.5);
		position: absolute;
		top: 0;
		right: 0;
		display: none;
	}
	.img-uploader-icon {
		width: 80px;
		height: 80px;
		line-height: 80px;
		font-size: 20px;
		color: #8c939d;
		text-align: center;
	}
}
/deep/.el-form-item--mini {
	.el-form-item__label {
		padding-bottom: 0;
	}
}
</style>
